export { default } from './ContractMaoTaxBannerContainer'
